import { getMenuItemStyles } from './menu-item-styles';

export const getNavigationBarTreeStyles = ({ navigationBarTree = {} }, { palette = {} }) => ({
  ...getMenuItemStyles({ navigationBarTree }, { palette }),

  treeViewContainer: {
    position: 'relative',
    overflowY: 'hidden',
    overflowX: 'hidden',
    height: '100vh',
    flex: '1 1 1px',
    '& .ReactVirtualized__Grid': {
      overflowY: 'hidden !important',
      '&:hover': {
        overflow: 'auto !important',
      },
    },
  },
  expandIconHidden: {
    display: 'none',
  },
  statusIconContainer: {
    width: 12,
    height: 12,
    marginLeft: 16,
    marginTop: 12,
    marginBottom: 12,
    marginRight: 16,
  },
  activeStatusIcon: {
    fontSize: '12px !important',
    color: '#22CD6E',
    display: 'block',
    top: '0 !important',
    margin: '0px !important',
  },
  pausedStatusIcon: {
    fontSize: '12px !important',
    color: '#BEBBB8',
    display: 'block',
    top: '0 !important',
    margin: '0px !important',
  },
  leafNodeTextContainer: {
    paddingLeft: 44,
  },
  pausedTextContainer: {
    fontStyle: 'italic',
  },
  hiddenTooltip: {
    display: 'none',
  },
  rootNodeSpinnerContainer: {
    paddingLeft: 16,
  },
  leafNodeSpinnerContainer: {
    paddingLeft: 44,
  },
  calloutTargetContainer: {
    width: '100%',
  },
  labelContainer: {
    color: palette.white,
  },
});
